<template>
  <div class="row">
    <div class="col">
      <div class="pb-1">Purchase option (for the first bill)</div>
      <div class="d-flex flex-row">
        <div class="form-check form-check-inline pr-15">
          <input
            class="form-check-input mr-2"
            id="purchase"
            type="radio"
            v-model="form.billType"
            name="billType"
            value="PURCHASE"
            :class="{
              'input--error': isSubmit && error.errorBillType,
            }"
          />
          <label class="form-check-label" for="purchase">Purchase</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input mr-2"
            id="free"
            type="radio"
            v-model="form.billType"
            name="billType"
            value="FREE"
            :class="{
              'input--error': isSubmit && error.errorBillType,
            }"
          />
          <label class="form-check-label" for="free">Free</label>
        </div>
      </div>
      <div v-if="isSubmit && error.errorBillType" class="text-error">
        {{ error.errorBillType.message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PurchaseOption",
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}
</style>
